/**
 * 检测 flex gap 支持情况。
 * 部分安卓 WebView（Chrome < 84）仅支持 grid gap，不支持 flex gap。
 * 不支持时给 html 打上 flex-gap-not-supported，配合 postcss flex-gap-polyfill。
 */
(function detectFlexGap() {
  try {
    const flex = document.createElement("div");
    flex.style.display = "flex";
    flex.style.flexDirection = "column";
    flex.style.rowGap = "1px";
    flex.appendChild(document.createElement("div"));
    flex.appendChild(document.createElement("div"));
    document.documentElement.appendChild(flex);
    const supported = flex.scrollHeight === 1;
    flex.parentNode.removeChild(flex);
    if (!supported) {
      document.documentElement.classList.add("flex-gap-not-supported");
    }
  } catch (e) {
    document.documentElement.classList.add("flex-gap-not-supported");
  }
})();
